module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/kate-koreneva-bkg-90a5ad8c4ad9b545b06e026eb895f967.jpg";